import React, { useEffect, useRef, useState } from "react";
import Like from "../../assets/like.png";
import Worst from "../../assets/Worst.png";
import Dislike from "../../assets/Dislike.png";
import Natural from "../../assets/Natural.png";
import Great from "../../assets/Great.png";
import useXoltarNavigation from "../../hooks/useXoltarNav";
import { useAppDispatch, useAppSelector } from "../../redux-stores/hooks/hooks";
import BaseCardView from "../../Components/BaseCardView/BaseCardView";
import { useSearchParams } from "react-router-dom";
import {
  selectQuestionnaireAnswer,
  setAnswer,
} from "../../redux-stores/reducers/QuestionerState";
import { Col, Container, Form, Row } from "react-bootstrap";
import { getBackendInfo } from "../../Components/Api/ServiceApi";
import { addFeedBack } from "../../Components/Api/EventApi";
import {
  selectQuestionFile,
  selectSiteFile,
} from "../../redux-stores/reducers/PageState";
import { selectConversationConvID } from "../../redux-stores/reducers/ConversationState";

const EmojiList = ["Worst", "Dislike", "Natural", "Like", "Great"] as const;

type EmojiVariant = typeof EmojiList[number];

const Emoji = (props: {
  variant: EmojiVariant;
  grayed: boolean | undefined;
  choosed?: number;
  onClick?: Function;
}) => {
  let image: string;
  let value: number;
  switch (props.variant) {
    case "Great":
      image = Great;
      value = EmojiList.findIndex((n) => n === props.variant);
      break;
    case "Like":
      image = Like;
      value = EmojiList.findIndex((n) => n === props.variant);
      break;
    case "Natural":
      image = Natural;
      value = EmojiList.findIndex((n) => n === props.variant);
      break;
    case "Dislike":
      image = Dislike;
      value = EmojiList.findIndex((n) => n === props.variant);
      break;
    case "Worst":
      image = Worst;
      value = EmojiList.findIndex((n) => n === props.variant);
      break;
  }
  return (
    <div
      className="emoji-btn"
      style={{
        display: "flex",
        cursor: "pointer",
        borderRadius: "29px",
        userSelect: "none",
        flexDirection: "column",
        flexGrow: "1",
        alignItems: "center",
      }}
      onClick={() => {
        props.onClick && props.onClick(value);
      }}
    >
      <img
        src={image}
        alt={`${props.variant} emoji`}
        style={{
          filter:
            props.grayed !== undefined && props.choosed !== value
              ? "grayscale(1)"
              : "grayscale(0)",
          aspectRatio: "1 / 1",
          minHeight: "1em",
          minWidth: "1em",
        }}
      />
      <span
        style={{
          textAlign: "center",
        }}
      >
        {props.variant}
      </span>
    </div>
  );
};

export const Feedback = () => {
  const navigate = useXoltarNavigation();
  const dispatch = useAppDispatch();
  const answers = useAppSelector(selectQuestionnaireAnswer);
  const siteFile = useAppSelector(selectSiteFile);
  const questionnaireFile = useAppSelector(selectQuestionFile);
  const conversation = useAppSelector(selectConversationConvID);
  const [stars, setStars] = useState(0);
  const [Chosen, setChosen] = useState<boolean | undefined>(undefined);
  const [feedbackId, setFeedbackId] = useState("");
  const [freeTextAnswer, setFreeTextAnswer] = useState("");
  const [params] = useSearchParams();
  const textField = useRef<HTMLTextAreaElement>(null);
  const emojiList = ["Worst", "Dislike", "Natural", "Like", "Great"];
  const [backend, setBackend] = useState<
    Awaited<ReturnType<typeof getBackendInfo>>
  >({ conv: undefined, webapp: undefined });
  const onNext = React.useCallback(async () => {
    if (backend.webapp)
      await addFeedBack(
        backend.webapp,
        feedbackId,
        stars + 1, //  adding one becaus it starts from 0
        freeTextAnswer,
        `How was the conversation $$extra info: ${JSON.stringify({
          siteFile,
          questionnaireFile,
          conversation,
        })}$$`
      );
    dispatch(setAnswer({ key: "feedbackId", value: "" }));
    navigate("Intro");
    // eslint-disable-next-line
  }, [backend, stars]);
  useEffect(() => {
    getBackendInfo().then(setBackend);
    return () => {};
  }, []);
  useEffect(() => {
    const _feedbackId = params.get("feedbackId") ?? answers["feedbackId"];
    console.debug(_feedbackId);
    if (!_feedbackId || _feedbackId === null) {
      navigate("Intro");
      return;
    }
    setFeedbackId(_feedbackId);
    // eslint-disable-next-line
  }, []);
  return (
    <BaseCardView
      pageName="Feedback"
      dynamicLoad
      disablePrevious
      hidePrev
      onNext={onNext}
      hideNext={!Chosen}
      disableNext={!Chosen}
      cardStyle={{ width: "100%" }}
      containerStyle={{ width: "100%" }}
      footerStyle={!Chosen ? { display: "none" } : {}}
      bodyComponent={(body: string) => (
        <Container style={{ width: "100%" }} fluid>
          <Row>
            <Col>
              <p className="Gotham-font" style={{ paddingLeft: "8px" }}>
                {body}
              </p>
            </Col>
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {emojiList.map((variant, index) => (
              <Col xs="2" key={index + Date.now() * Math.random()}>
                <Emoji
                  choosed={stars}
                  variant={variant as EmojiVariant}
                  grayed={Chosen}
                  onClick={() => {
                    console.debug("index", index);
                    setStars(index);
                    setChosen(
                      index !== stars || Chosen === undefined ? true : undefined
                    );
                  }}
                />
              </Col>
            ))}
          </Row>
          <Row>
            {Chosen ? (
              <>
                <Form.Label>Want to tell us more?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  ref={textField}
                  value={freeTextAnswer}
                  onChange={(e) => {
                    setFreeTextAnswer(e.target.value);
                  }}
                />
              </>
            ) : null}
          </Row>
        </Container>
      )}
    />
  );
};
